// extracted by mini-css-extract-plugin
module.exports = {"antRow":"SuperTeamCollab_antRow__2rWcY","addForm":"SuperTeamCollab_addForm__1EwMX"};